<template>
  <div class="input-group">
    <input class="form-control" v-model="value" @focus="open=false" :placeholder="schema.placeholder" />
    <Chrome
      class="color-picker"
      v-if="open"
      v-model="value"
      :disableAlpha="true"
      :disableFields="true"
      @click.native="$nextTick(() => open=true)"
    />
    <label @click="open = !open">
      <span v-bind:style="{background: indicator}">&nbsp;</span>
    </label>
  </div>
</template>

<script>
  import { Chrome } from 'vue-color'
  import {abstractField} from "vue-form-generator";

  export default {
    name: 'field-color',
    mixins: [abstractField],
    components: {Chrome},
    data () {return {
      open: false,
      listener: () => this.open = false,
    }},
    computed: {
      placeholder () {
        return this.schema.placeholder || false;
      },
      indicator () {
        if (this.value || this.schema.default) {
          return this.color;
        } else if (this.schema.placeholder) {
          return this.schema.placeholder;
        }
      },
      color () {
        if (this.value) {
          var value = this.value;
          if (typeof value === 'object' && value.hex) {
            value = value.hex;
          }
          if (value.substr(0, 1) !== '#') {
            value = '#' + value;
          }
          if (this.testcolor(value)) {
            return value;
          }
        } else if (this.schema.default) {
          return this.schema.default;
        } else if (this.schema.required) {
          return '#CCCCCC';
        } else {
          return '';
        }
      },
    },
    methods: {
      testcolor (value) {
        return /^#[a-fA-F0-9]{6}$/.test(value);
      },
      fixvalue () {
        if (this.color !== this.value) {
          this.value = this.color;
        }
      }
    },
    mounted () {this.fixvalue();},
    watch: {
      value () {this.fixvalue();},
      color () {this.fixvalue();},
      open (open) {
        if (open) {
          if (!this.value || !this.testcolor(this.value)) {
            this.value = '#CCCCCC';
          }
          document.addEventListener('click', this.listener);
        } else {
          document.removeEventListener('click', this.listener);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .input-group {
    position: relative;
    .form-control {
      width: calc(100% - 42px);
    }
    label {
      padding: 2px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 42px;
        height: 42px;
      }
    }
  }
  .color-picker {
    position: absolute;
    right: 2px;
    top: 100%;
    z-index: 20;
  }
</style>



// WEBPACK FOOTER //
// src/helpers/mixins/form/ColorPicker.vue